import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { config } from '../../../../../config/config';
import { CreateWholeTripCommand, TripStorageCommand } from '../../../../commands/visitor/create.trip.command';
import { SocialLoginPopupComponent } from '../../../../common/components/social.login.popup/social.login.popup.component';
import { LocalStorageService } from '../../../../services/localStorageService';
import { ShareService } from '../../../../services/share.service';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import { guid } from '../../../../utils/guid';
import { BaseComponent } from '../../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { FacebookLoginButtonComponent } from '../../../../common/components/facebook.login.button/facebook.login.button.component';
import { ButtonTriggerEvent } from '../../../../common/components';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { HubAnalytics } from '../trip.side.bar/visitor.trip.side.bar.component';
import { ShareTripModalActions, ShareTripModalData } from './share.trip.modal.provider';
import {GlobalEventEmitter} from "../../../../common/services/global.event.emitter";

@Component({
    templateUrl: './share.trip.modal.component.html',
    styleUrls: ['./share.trip.modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ShareTripModalComponent extends BaseComponent {

    public data: ShareTripModalData;
    public hubName: string;
    public helpFormGroup: FormGroup;
    public emailFormGroup: FormGroup;
    public help = {
        hubName: '',
        name: '',
        number: '',
        email: '',
        comment: '',
        inquiryEmail: ''
    };
    public shareToEmails = '';
    @ViewChild('sendEmailsSuccess') public sendEmailsSuccess: SuccessWrapComponent;
    @ViewChild('sendHelpSuccess') public sendHelpSuccess: SuccessWrapComponent;

    constructor(private dialogRef: MatDialogRef<ShareTripModalComponent>,
                private activatedRoute: ActivatedRoute,
                private actions: ShareTripModalActions,
                private formBuilder: FormBuilder,
                private visitorApiService: VisitorApiService,
                data: ShareTripModalData) {
        super({activatedRoute});
        this.data = Object.assign({}, data);

        this.helpFormGroup = this.formBuilder.group({
            'name': [null, [Validators.required]],
            'number': [null],
            'email': new FormControl('', Validators.compose([
                Validators.required,
                Validators.pattern(config.emailPattern)
            ])),
            'comment': [null, [Validators.required]],
        });

        this.emailFormGroup = this.formBuilder.group({
            'shareToEmails': new FormControl('', Validators.compose([
                Validators.required,
                Validators.pattern(config.emailPattern)
            ])),
        });

        setTimeout(() => {
            const googleSigninBtn = document.getElementById("google-signin-btn-trip");
            google['accounts'].id.renderButton(
                googleSigninBtn,
                {theme: "outline", size: "large"}
            );
            googleSigninBtn.onclick = () => {
                this.close();
            };

            GlobalEventEmitter.on('onGoogleLoginStatusChanged', () => {
                console.log('onGoogleLoginStatusChanged received');
                document.querySelector('body').click(); // make sure it it closed
                this.close();
            });
        });
    }

    public get shareTitle() {
        if (this.data.type === 'trip') {
            if (this.data.isWholeTrip) {
                return 'MY TRIPS';
            } else {
                return 'THE TRIP: ' + this.data.title;
            }
        } else if (this.data.type === 'tour') {
            return 'THE ITINERARY';
        }
    }

    public get isUserLoggedIn() {
        return SocialLoginPopupComponent.isUserLoggedIn;
    }

    public close(): void {
        if (this.actions.cancel) {
            this.actions.cancel();
        }

        GlobalEventEmitter.off('onGoogleLoginStatusChanged');
        this.dialogRef.close();
    }

    public FBLoggedIn($event) {
        if (this.actions.confirm) {
            this.actions.confirm($event, 'fb');
        }
        GlobalEventEmitter.off('onGoogleLoginStatusChanged');
        this.dialogRef.close();
    }

    public GoogleLogin($event) {
        if (this.actions.confirm) {
            this.actions.confirm($event, 'google');
        }
        GlobalEventEmitter.off('onGoogleLoginStatusChanged');
        this.dialogRef.close();
    }

    public sendHelp(event: ButtonTriggerEvent) {
        this.help.hubName = this.data.hubName;
        this.visitorApiService.sendHelp(this.help).finally(event.complete).subscribe(data => {
            this.sendHelpSuccess.success();
        });
    }

    public sendShareEmails(event: ButtonTriggerEvent) {
        if (!this.shareToEmails) {
            return;
        }

        if (this.data.type === 'trip') {
            let {tripId} = this.allRouteParams;
            if (tripId || this.data.wholeTripId) {
                this.visitorApiService.sendEmails(
                    this.shareToEmails,
                    ShareService.getTripLink(this.data.hubName, tripId || this.data.wholeTripId, this.data.singleTripId),
                    this.data.hubName)
                    .finally(event.complete)
                    .subscribe(data => {
                    this.sendEmailsSuccess.success();
                });
            } else {
                this.getTripIDAndShare('send-emails', event);
            }
            this.addShareUserTripCount();
        } else if (this.data.type === 'tour') {
            let {tourId} = this.allRouteParams;
            if (!tourId) {
                tourId = this.data.wholeTripId;
            }
            this.visitorApiService.sendEmails(this.shareToEmails, ShareService.getTourLink(this.data.hubName, tourId), this.data.hubName).finally(event.complete).subscribe(data => {
                this.sendEmailsSuccess.success();
            });
            if (config.isAnalyticsOn) {
                this.visitorApiService.addShareCount(this.data.hubName, tourId).subscribe();
            }
        }
    }

    public shareByEmailApp() {
        if (this.data.type === 'trip') {
            let {tripId} = this.allRouteParams;
            if (tripId || this.data.wholeTripId) {
                window.location.href = ShareService.toMailableTrip(this.data.hubName, tripId || this.data.wholeTripId, this.data.singleTripId);
            } else {
                this.getTripIDAndShare('email');
            }
            this.addShareUserTripCount();
        } else if (this.data.type === 'tour') {
            let {tourId} = this.allRouteParams;
            if (!tourId) {
                tourId = this.data.wholeTripId;
            }
            window.location.href = ShareService.toMailableTour(this.data.hubName, tourId);
            if (config.isAnalyticsOn) {
                this.visitorApiService.addShareCount(this.data.hubName, tourId).subscribe();
            }
        }
    }

    public shareTweet() {
        if (this.data.type === 'trip') {
            let {tripId} = this.allRouteParams;
            if (tripId || this.data.wholeTripId) {
                ShareService.tweetTrip(this.data.hubName, tripId || this.data.wholeTripId, this.data.singleTripId);
            } else {
                this.getTripIDAndShare('tweet');
            }
            this.addShareUserTripCount();
        } else if (this.data.type === 'tour') {
            let {tourId} = this.allRouteParams;
            if (!tourId) {
                tourId = this.data.wholeTripId;
            }
            ShareService.tweetTour(this.data.hubName, tourId);
            if (config.isAnalyticsOn) {
                this.visitorApiService.addShareCount(this.data.hubName, tourId).subscribe();
            }
        }
    }

    public shareFacebook() {
        if (this.data.type === 'trip') {
            let {tripId} = this.allRouteParams;
            if (tripId || this.data.wholeTripId) {
                ShareService.facebookShareTrip(this.data.hubName, tripId || this.data.wholeTripId, this.data.singleTripId);
            } else {
                this.getTripIDAndShare('facebook');
            }
            this.addShareUserTripCount();
        } else if (this.data.type === 'tour') {
            let {tourId} = this.allRouteParams;
            if (!tourId) {
                tourId = this.data.wholeTripId;
            }
            ShareService.facebookShareTour(this.data.hubName, tourId);
            if (config.isAnalyticsOn) {
                this.visitorApiService.addShareCount(this.data.hubName, tourId).subscribe();
            }
        }
    }

    private addShareUserTripCount() {
        let analytics = new HubAnalytics();
        analytics.tripPlanner.shareClickCount = 1;
        if (config.isAnalyticsOn) {
            this.visitorApiService.updateTripPlanerAnalytics(this.data.hubName, analytics).subscribe();
        }
    }

    private getTripIDAndShare(shareBy, event?: ButtonTriggerEvent) {
        let userID = SocialLoginPopupComponent.userId;
        //let {hubName} = this.allRouteParams;
        this.visitorApiService.getUserTrips(this.data.hubName, userID).subscribe(trip => {
            if (!trip || !trip.id) {
                let key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.data.hubName);
                let storage = localStorage.getItem(key);
                let tripsInCookie = JSON.parse(storage) as TripStorageCommand;

                let command = new CreateWholeTripCommand();
                command.id = guid();
                command.userFacebookId = userID;
                command.hubName = this.data.hubName;
                command.trips = tripsInCookie.trips;
                this.visitorApiService.syncTripsToDB(this.data.hubName, command).subscribe(() => {
                        this.data.wholeTripId = command.id;
                        if (!this.data.isWholeTrip && command.trips.length > this.data.singleTripIndex) {
                            this.data.singleTripId = command.trips[this.data.singleTripIndex].id;
                        }
                        this.shareByType(shareBy, event);
                    }
                );
            } else {
                this.data.wholeTripId = trip.id;
                if (!this.data.isWholeTrip && trip.trips.length > this.data.singleTripIndex) {
                    this.data.singleTripId = trip.trips[this.data.singleTripIndex].id;
                }
                this.shareByType(shareBy, event);
            }
        });
    }

    private shareByType(shareBy, event?: ButtonTriggerEvent) {
        if (shareBy === 'email') {
            window.location.href = ShareService.toMailableTrip(this.data.hubName, this.data.wholeTripId, this.data.singleTripId);
        } else if (shareBy === 'facebook') {
            ShareService.facebookShareTrip(this.data.hubName, this.data.wholeTripId, this.data.singleTripId);
        } else if (shareBy === 'tweet') {
            ShareService.tweetTrip(this.data.hubName, this.data.wholeTripId, this.data.singleTripId);
        } else if (shareBy === 'send-emails') {
            this.visitorApiService.sendEmails(this.shareToEmails, ShareService.getTripLink(this.data.hubName, this.data.wholeTripId, this.data.singleTripId), this.data.hubName)
                .finally(event && event.complete)
                .subscribe(data => {
                    this.sendEmailsSuccess.success();
                });
        }
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/share.trip.modal/share.trip.modal.component.ts